<template>
  <div>
    <v-app-bar app color="#000000" dark elevation="0" height="55" class="nfcero-header">
      <div class="nfcero-header-content">
        <template v-if="isAuthenticated">
          <v-app-bar-nav-icon 
            id="onboarding-menu-toggle"
            @click.stop="drawer = !drawer"
            class="auth-menu-toggle"
          ></v-app-bar-nav-icon>
        </template>

        <!-- Logo -->
        <router-link :to="isAuthenticated ? '/dashboard/templates' : '/'" class="text-decoration-none d-flex align-center nfcero-logo">
          <v-img
            :src="require('@/assets/logoBlanco.png')"
            max-width="108px"
            max-height="19px"
            contain
          ></v-img>
        </router-link>

        <v-spacer></v-spacer>

        <v-spacer></v-spacer>

        <template v-if="!isAuthenticated">
          <!-- Menú para usuarios no autenticados -->
          <!-- Desktop Menu links -->
          <div class="d-none d-md-flex align-center nav-links">
            <a 
              href="javascript:void(0)" 
              class="nav-link"
              @click="$emit('scroll-to-section', 'about-nfcero')"
            >
              ¿Qué es NFCERO?
            </a>
            <a 
              href="javascript:void(0)" 
              class="nav-link"
              @click="$emit('scroll-to-section', 'explore-section')"
            >
              Explora
            </a>
            <a 
              href="javascript:void(0)" 
              class="nav-link"
              @click="$emit('scroll-to-section', 'faqs-section')"
            >
              FAQs
            </a>
            <a 
              href="javascript:void(0)" 
              class="nav-link"
              @click="$emit('scroll-to-section', 'contact-section')"
            >
              Contacto
            </a>
            <router-link to="/tienda" class="nav-link">
              Tienda
            </router-link>
            <router-link to="/instrucciones" class="nav-link">
              ¿Cómo funciona?
            </router-link>
          </div>

          <!-- Cart Icon -->
          <cart-icon @click="$emit('open-cart')" class="ml-2 mr-2 public-cart-icon" />

          <!-- Login Button -->
          <v-btn 
            class="login-btn ml-2 mr-5" 
            @click="showLoginDialog = true"
            small
            depressed
          >
            Iniciar sesión
          </v-btn>

          <!-- Mobile Menu Icon -->
          <div class="d-md-none ml-2">
            <v-menu offset-y>
              <template #activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" width="44" height="44" aria-label="Menú">
                  <v-icon>mdi-menu</v-icon>
                </v-btn>
              </template>
              <v-sheet color="black" class="mobile-menu-sheet">
                <v-list dark class="mobile-menu-list">
                  <v-list-item @click="$emit('scroll-to-section', 'about-nfcero')">
                    <v-list-item-title>¿Qué es NFCERO?</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('scroll-to-section', 'explore-section')">
                    <v-list-item-title>Explora</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('scroll-to-section', 'faqs-section')">
                    <v-list-item-title>FAQs</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="$emit('scroll-to-section', 'contact-section')">
                    <v-list-item-title>Contacto</v-list-item-title>
                  </v-list-item>
                  <v-list-item to="/tienda">
                    <v-list-item-title>Tienda</v-list-item-title>
                  </v-list-item>
                  <v-list-item to="/instrucciones">
                    <v-list-item-title>¿Cómo funciona?</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-sheet>
            </v-menu>
          </div>
        </template>

        <template v-else>
          <div class="d-none d-md-flex align-center nav-links auth-nav-links">
            <router-link to="/dashboard/templates" class="nav-link">
              Mis NFCero's
            </router-link>
            <router-link to="/dashboard/form-data" class="nav-link">
              Formularios
            </router-link>
            <router-link to="/dashboard/calendar" class="nav-link">
              Calendario
            </router-link>
            <router-link to="/dashboard/file-manager" class="nav-link">
              Archivos
            </router-link>
            <router-link to="/tienda" class="nav-link">
              Tienda
            </router-link>
          </div>

          <v-spacer class="d-none d-md-flex"></v-spacer>

          <cart-icon @click="$emit('open-cart')" class="ml-2 auth-cart-icon" />

          <v-btn 
            v-if="Number(currentUser?.currentPlanId) !== 3"
            to="/dashboard/settings/billing"
            small 
            class="ml-3 d-none d-md-inline-flex upgrade-btn"
          >
            <v-icon small class="mr-1">mdi-upgrade</v-icon>
            <span class="text-caption upgrade-btn-text">Mejora tu suscripción</span>
          </v-btn>

          <div class="white-divider d-none d-md-inline-block mx-4"></div>

          <v-menu offset-y>
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="profile-btn mr-5 d-none d-md-inline-flex"
              >
                <v-avatar size="32" class="user-avatar mr-2">
                  <v-img
                    :src="currentUser?.avatar || require('@/assets/avatar.jpg')"
                    alt="Avatar"
                  ></v-img>
                </v-avatar>
                <span class="text-caption profile-name">{{ userFirstName }}</span>
              </v-btn>
            </template>

            <v-list class="user-menu" dense>
              <v-list-item to="/dashboard/settings/profile">
                <v-list-item-icon>
                  <v-icon small>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Perfil</v-list-item-title>
              </v-list-item>

              <v-list-item to="/dashboard/settings/billing">
                <v-list-item-icon>
                  <v-icon small>mdi-credit-card</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Facturación</v-list-item-title>
              </v-list-item>

              <v-list-item to="/dashboard/settings/password">
                <v-list-item-icon>
                  <v-icon small>mdi-lock</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Contraseña</v-list-item-title>
              </v-list-item>

              <v-divider></v-divider>

              <v-list-item @click="handleLogout">
                <v-list-item-icon>
                  <v-icon small>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Cerrar Sesión</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </div>
    </v-app-bar>

    <!-- Login Dialog -->
    <v-dialog v-model="showLoginDialog" max-width="450px">
      <v-card class="login-dialog">
        <v-toolbar color="#69032E" dark flat>
          <v-toolbar-title class="font-weight-medium">Iniciar sesión</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showLoginDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-6">
          <v-form @submit.prevent="handleLogin">
            <v-text-field
              v-model="loginForm.email"
              label="Correo electrónico"
              name="email"
              prepend-inner-icon="mdi-account"
              type="text"
              :rules="[rules.required, rules.email]"
              required
              outlined
              dense
              @keyup.enter="handleLogin"
            ></v-text-field>
            <v-text-field
              v-model="loginForm.password"
              label="Contraseña"
              name="password"
              prepend-inner-icon="mdi-lock"
              :type="showLoginPassword ? 'text' : 'password'"
              :append-icon="showLoginPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              required
              outlined
              dense
              @click:append="showLoginPassword = !showLoginPassword"
              @keyup.enter="handleLogin"
            ></v-text-field>
            <v-alert v-if="loginError" type="error" dense class="mb-3">
              {{ loginError }}
            </v-alert>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-btn 
            color="#69032E" 
            dark
            block
            large
            @click="handleLogin" 
            :loading="loginLoading"
            depressed
          >
            Ingresar
          </v-btn>
        </v-card-actions>
        <v-card-text class="text-center pb-6">
          <v-btn 
            text
            color="#1d1d20"
            class="forgot-link"
            @click="showForgotPasswordDialog = true"
            :disabled="loginLoading"
          >
            ¿Olvidaste tu contraseña?
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Forgot Password Dialog -->
    <v-dialog v-model="showForgotPasswordDialog" max-width="450px">
      <v-card class="login-dialog">
        <v-toolbar color="#69032E" dark flat>
          <v-toolbar-title class="font-weight-medium">Recuperar Contraseña</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showForgotPasswordDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-6">
          <p class="mb-4 text-body-2 grey--text">
            Ingresa tu correo electrónico y te enviaremos un enlace para restaurar tu contraseña.
          </p>
          <v-form @submit.prevent="submitForgotEmail">
            <v-text-field
              v-model="forgotPasswordForm.email"
              label="Correo electrónico"
              prepend-icon="mdi-account"
              type="text"
              :rules="[rules.required, rules.email]"
              required
              outlined
              dense
            ></v-text-field>
            <v-alert v-if="forgotPasswordError || forgotPasswordSuccess" type="success" dense class="mb-3">
              {{ forgotPasswordSuccess || forgotPasswordError }}
            </v-alert>
          </v-form>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn 
            text
            @click="showForgotPasswordDialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn 
            color="#69032E" 
            dark
            @click="submitForgotEmail" 
            :loading="forgotPasswordLoading"
            depressed
          >
            Enviar Enlace
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Register Dialog -->
    <v-dialog v-model="showRegisterDialog" max-width="500px">
      <v-card class="register-dialog">
        <v-card-title class="register-title">
          <span class="text-h5 font-weight-medium">Registro Anticipado</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeRegisterDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form @submit.prevent="handleRegisterWithInvitation">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="registerForm.name"
                    label="Nombre completo"
                    :rules="[rules.required]"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="registerForm.email"
                    label="Correo electrónico"
                    :rules="[rules.required, rules.email]"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="registerForm.password"
                    label="Contraseña"
                    type="password"
                    :rules="[rules.required, rules.minLength]"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="registerForm.invitationCode"
                    label="Código de Invitación"
                    :rules="[rules.required]"
                    required
                    placeholder="Ingresa tu código de invitación"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-alert v-if="registerError" type="error" dense class="mt-3">
                {{ registerError }}
              </v-alert>
              <v-alert v-if="registerSuccess" type="success" dense class="mt-3">
                {{ registerSuccess }}
              </v-alert>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeRegisterDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="#69032E"
            dark
            depressed
            @click="handleRegisterWithInvitation"
            :loading="registerLoading"
          >
            Registrarse
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Navigation Drawer (Mobile for authenticated users) -->
    <v-navigation-drawer
      v-model="drawer"
      app
      v-if="isAuthenticated"
      color="#000000"
      dark
      :mobile-breakpoint="1264"
      width="276"
      class="authenticated-drawer"
      :temporary="$vuetify.breakpoint.smAndDown"
    >
      <v-list>
        <v-divider class="divider-guinda"></v-divider>

        <v-list-group
          id="onboarding-menu-sites"
          :value="true"
          no-action
          class="drawer-group"
        >
          <template v-slot:activator>
            <v-list-item-icon>
              <v-img
                :src="require('@/assets/logoBlanco.png')"
                max-width="18px"
                contain
                class="drawer-icon"
              ></v-img>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Mis NFCERO</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/dashboard/templates" class="drawer-submenu-item">
            <v-list-item-content>
              <v-list-item-title>Ver todos</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            v-for="website in websites"
            :key="website.id"
            class="drawer-submenu-item"
            @click="goToWebsiteEditor(website)"
          >
            <v-list-item-icon class="drawer-plus-icon">
              <span>+</span>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ website.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item to="/dashboard/clientes" class="drawer-item">
          <v-list-item-icon>
            <v-icon>mdi-account-heart-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Clientes</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="my-0">
            <span class="drawer-tag">VIP</span>
          </v-list-item-action>
        </v-list-item>

        <v-list-item id="onboarding-menu-forms" to="/dashboard/form-data" class="drawer-item">
          <v-list-item-icon>
            <v-icon>mdi-form-select</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Formularios</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item id="onboarding-menu-calendar" to="/dashboard/calendar" class="drawer-item">
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Calendario</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item id="onboarding-menu-files" to="/dashboard/file-manager" class="drawer-item">
          <v-list-item-icon>
            <v-icon>mdi-folder</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Archivos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="divider-guinda my-2"></v-divider>

        <v-list-item to="/tienda" class="drawer-item">
          <v-list-item-icon>
            <v-icon>mdi-store</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Tienda</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="divider-guinda my-2"></v-divider>

        <v-list-group
          prepend-icon="mdi-cog"
          no-action
          class="drawer-group"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Configuración</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item to="/dashboard/settings/profile" class="drawer-subitem">
            <v-list-item-icon>
              <v-icon small>mdi-account</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Perfil</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/dashboard/settings/billing" class="drawer-subitem">
            <v-list-item-icon>
              <v-icon small>mdi-credit-card</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Facturación</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/dashboard/settings/password" class="drawer-subitem">
            <v-list-item-icon>
              <v-icon small>mdi-lock</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cambiar Contraseña</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>

      <template v-slot:append>
        <v-divider class="divider-guinda"></v-divider>
        <v-list>
          <v-list-item @click="handleLogout" class="drawer-item logout-item">
            <v-list-item-icon>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cerrar sesión</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AuthService from '@/services/auth'
import WebsiteService from '@/services/website'
import OnboardingService from '@/services/onboarding'
import CartIcon from '@/components/CartIcon.vue'

export default {
  name: 'AppHeader',

  components: {
    CartIcon
  },

  data: () => ({
    drawer: true,
    websites: [],
    showLoginDialog: false,
    showRegisterDialog: false,
    showForgotPasswordDialog: false,
    loginForm: {
      email: '',
      password: ''
    },
    showLoginPassword: false,
    registerForm: {
      name: '',
      email: '',
      password: '',
      invitationCode: ''
    },
    forgotPasswordForm: {
      email: ''
    },
    loginError: null,
    loginLoading: false,
    registerError: null,
    registerSuccess: null,
    registerLoading: false,
    forgotPasswordError: null,
    forgotPasswordSuccess: null,
    forgotPasswordLoading: false,
    rules: {
      required: value => !!value || 'Requerido.',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Correo inválido.'
      },
      minLength: value => value.length >= 6 || 'La contraseña debe tener al menos 6 caracteres.'
    }
  }),

  computed: {
    ...mapGetters(['isAuthenticated', 'currentUser']),
    
    userFirstName() {
      if (this.currentUser?.name) {
        return this.currentUser.name.split(' ')[0]
      }
      return 'Perfil'
    }
  },

  created() {
    if (this.isAuthenticated) {
      this.loadWebsites()
    }
  },

  watch: {
    isAuthenticated(isAuthenticated) {
      if (isAuthenticated) {
        this.drawer = true
        this.loadWebsites()
      } else {
        this.websites = []
      }
    },
    showForgotPasswordDialog(value) {
      // Limpiar formulario cuando se cierre el modal
      if (!value) {
        this.forgotPasswordForm = { email: '' };
        this.forgotPasswordError = null;
        this.forgotPasswordSuccess = null;
      }
    }
  },

  methods: {
    ...mapActions(['logout']),
    
    async handleLogin() {
      this.loginLoading = true;
      this.loginError = null;
      try {
        await AuthService.login({
          email: this.loginForm.email,
          password: this.loginForm.password,
        });
        
        // Activar onboarding si es la primera vez
        OnboardingService.triggerOnboarding();
        
        this.showLoginDialog = false;
        this.loginForm = { email: '', password: '' };
        this.$router.push('/dashboard/templates');
      } catch (error) {
        // ✅ SUBSCRIPTION_EXPIRED: Redirigir a /billing-expired
        if (error.code === 'SUBSCRIPTION_EXPIRED') {
          // Guardar datos temporales de usuario en sessionStorage
          const email = this.loginForm.email;
          const date = error.expiryDate;
          const token = error.token; // ✅ Guardar token temporal
          
          console.log('🔑 DEBUG AppHeader:', { email, date, token });
          
          sessionStorage.setItem('expiredUserEmail', email);
          sessionStorage.setItem('expiredUserExpiryDate', date);
          sessionStorage.setItem('expiredUserToken', token); // ✅ Token para requests autenticados
          
          console.log('💾 Datos guardados en sessionStorage:', {
            email: sessionStorage.getItem('expiredUserEmail'),
            token: sessionStorage.getItem('expiredUserToken'),
            date: sessionStorage.getItem('expiredUserExpiryDate')
          });
          
          this.showLoginDialog = false;
          this.loginForm = { email: '', password: '' };
          
          // Usar window.location.href en vez de router.push para evitar interferencia del guard
          window.location.href = '/billing-expired';
          return;
        }
        
        this.loginError = error.message || 'Ocurrió un error al iniciar sesión.';
      } finally {
        this.loginLoading = false;
      }
    },

    async handleRegisterWithInvitation() {
      this.registerLoading = true;
      this.registerError = null;
      this.registerSuccess = null;
      
      try {
        await AuthService.registerWithInvitation({
          name: this.registerForm.name,
          email: this.registerForm.email,
          password: this.registerForm.password,
          invitationCode: this.registerForm.invitationCode
        });
        
        this.registerSuccess = 'Registro exitoso. Redirigiendo a tus templates...';
        
        // Activar onboarding para nuevos usuarios
        OnboardingService.triggerOnboarding();
        
        // Esperar un momento para mostrar el mensaje de éxito
        setTimeout(() => {
          this.showRegisterDialog = false;
          this.$router.push('/dashboard/templates');
        }, 2000);
        
      } catch (error) {
        this.registerError = error.message || 'Ocurrió un error al registrarse.';
      } finally {
        this.registerLoading = false;
      }
    },

    closeRegisterDialog() {
      this.showRegisterDialog = false;
      this.registerForm = {
        name: '',
        email: '',
        password: '',
        invitationCode: ''
      };
      this.registerError = null;
      this.registerSuccess = null;
    },

    async submitForgotEmail() {
      this.forgotPasswordLoading = true;
      this.forgotPasswordError = null;
      this.forgotPasswordSuccess = null;
      
      try {
        await AuthService.requestPasswordReset(this.forgotPasswordForm.email);
        this.forgotPasswordSuccess = 'Se ha enviado un enlace de recuperación a tu correo. Por favor, revisa tu bandeja de entrada.';
        
        // El modal permanece abierto - el usuario debe cerrarlo manualmente
        
      } catch (error) {
        this.forgotPasswordError = error.message || 'Error al enviar el correo de recuperación. Por favor, intenta nuevamente.';
      } finally {
        this.forgotPasswordLoading = false;
      }
    },

    async handleLogout() {
      try {
        await AuthService.logout()
        this.$router.push('/')
      } catch (error) {
        console.error('Error al cerrar sesión:', error)
      }
    },

    // Métodos para control programático del drawer (usado por onboarding)
    openDrawer() {
      this.drawer = true
    },

    closeDrawer() {
      this.drawer = false
    },

    toggleDrawer() {
      this.drawer = !this.drawer
    },

    async loadWebsites() {
      try {
        const response = await WebsiteService.getAllByUser()
        const websites = response?.websites || []
        this.websites = websites.map((website) => {
          const content = website.content || {}
          let profile = {}

          if (content.profile) {
            profile = content.profile || {}
          } else {
            profile = content.es?.profile || content.en?.profile || {}
          }

          return {
            id: website.id,
            name: website.title || profile.name || 'Sin nombre'
          }
        })
      } catch (error) {
        this.websites = []
      }
    },

    goToWebsiteEditor(website) {
      this.$router.push(`/dashboard/create-nfcero-v2/${website.id}`)
    },

    // Método público para abrir el diálogo de login desde otros componentes
    openLoginDialog() {
      this.showLoginDialog = true
    }
  }
}
</script>

<style scoped>
/* === Colors === */
:root {
  --nfcero-black: #000000;
  --nfcero-guinda: #69032E;
  --nfcero-guinda-light: #931B4D;
  --nfcero-gray-dark: #282828;
  --nfcero-gray-semi: #4C4C4C;
  --nfcero-gray-soft: #C4C4C4;
}

/* === Header === */
.nfcero-header {
  border-bottom: 1px solid #282828 !important;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
              linear-gradient(90deg, #000000 0%, #000000 100%) !important;
}

.nfcero-header::v-deep .v-toolbar__content {
  padding: 0 !important;
}

.nfcero-header-content {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.nfcero-logo {
  flex-shrink: 0;
  min-height: 44px; /* Auditoría responsive R10: área de toque */
  padding: 0 16px;
  margin: 0;
  display: flex;
  align-items: center;
}

/* === Navigation Links === */
.nav-links {
  gap: 16px;
}

.nav-link {
  color: white !important;
  text-decoration: none;
  font-size: 15.7px;
  font-weight: 400;
  padding: 8px 12px;
  transition: color 0.2s ease;
  white-space: nowrap;
}

.nav-link:hover {
  color: #931B4D !important;
}

/* === Login Button === */
.login-btn {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%), 
              linear-gradient(90deg, #69032E 0%, #69032E 100%) !important;
  border: 0.8px solid #540225 !important;
  border-radius: 6.7px !important;
  color: #f5f5f5 !important;
  font-size: 12.5px !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  padding: 8px 16px !important;
  height: auto !important;
  min-height: 40px; /* Auditoría responsive R4 */
  min-width: auto !important;
}

.login-btn:hover {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.1) 100%), 
              linear-gradient(90deg, #931B4D 0%, #931B4D 100%) !important;
}

/* === Mobile Menu === */
.mobile-menu-sheet {
  border-radius: 8px !important;
}

.mobile-menu-list {
  background: transparent !important;
}

.mobile-menu-list .v-list-item:hover {
  background-color: #282828 !important;
}

.mobile-menu-list .v-list-item__title {
  font-size: 14px;
}

/* === Header overflow fix === */
.nfcero-header {
  overflow: hidden !important;
}

.nfcero-header::v-deep .v-toolbar__content {
  max-width: 100% !important;
  overflow: hidden !important;
}

.auth-menu-toggle {
  margin-right: 8px;
  margin-left: 0;
}

.auth-nav-links {
  display: none !important;
}

.auth-user-button {
  border: none !important;
  box-shadow: none !important;
  width: auto;
  min-width: auto;
  height: auto;
  padding: 0 !important;
}

/* === Upgrade Button === */
.upgrade-btn {
  background-color: #822a4c !important;
  color: white !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-radius: 6px !important;
  padding: 8px 16px !important;
  height: 36px !important;
  font-size: 13px !important;
}

.upgrade-btn-text {
  font-weight: 700 !important;
}

.upgrade-btn::v-deep .v-btn__content {
  color: white !important;
}

.upgrade-btn:hover {
  background-color: #9d3359 !important;
  color: white !important;
}

/* === Profile Button === */
.profile-btn {
  border: 1.5px solid #822a4c !important;
  background-color: transparent !important;
  color: white !important;
  padding: 6px 12px !important;
  border-radius: 6px !important;
  text-transform: none !important;
  height: auto !important;
}

.profile-btn:hover {
  background-color: rgba(130, 42, 76, 0.1) !important;
  border-color: #9d3359 !important;
}

.profile-btn::v-deep .v-btn__content {
  color: white !important;
  display: flex;
  align-items: center;
}

.profile-name {
  color: white !important;
  font-weight: 500 !important;
}

.white-divider {
  background-color: white;
  width: 2px;
  height: 22px;
  display: inline-block;
  vertical-align: middle;
}

/* === User Menu === */
.user-avatar {
  border: none !important;
}

.user-menu {
  background-color: #000000 !important;
}

.user-menu .v-list-item {
  color: white !important;
}

.user-menu .v-list-item:hover {
  background-color: #282828 !important;
}

.user-menu .v-list-item__title {
  color: white !important;
  font-size: 13px;
}

.user-menu .v-list-item__icon .v-icon {
  color: #C4C4C4 !important;
}

/* === Dialogs === */
.login-dialog,
.register-dialog {
  background-color: #000000 !important;
  border: 1px solid #282828;
  border-radius: 16px !important;
}

.login-dialog .v-card__text,
.register-dialog .v-card__text {
  color: white !important;
}

.login-dialog .v-input,
.register-dialog .v-input {
  color: white !important;
}

.login-dialog::v-deep .v-text-field .v-label,
.register-dialog::v-deep .v-text-field .v-label {
  color: #C4C4C4 !important;
}

.login-dialog::v-deep .v-text-field .v-input__slot,
.register-dialog::v-deep .v-text-field .v-input__slot {
  border-color: #4C4C4C !important;
}

.login-dialog::v-deep .v-text-field--outlined fieldset,
.register-dialog::v-deep .v-text-field--outlined fieldset {
  border-color: #4C4C4C !important;
}

.login-dialog::v-deep .v-text-field--outlined:hover fieldset,
.register-dialog::v-deep .v-text-field--outlined:hover fieldset {
  border-color: #931B4D !important;
}

.login-dialog::v-deep .v-text-field--outlined.v-input--is-focused fieldset,
.register-dialog::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #931B4D !important;
}

.login-dialog::v-deep .v-icon,
.register-dialog::v-deep .v-icon {
  color: #C4C4C4 !important;
}

.login-dialog::v-deep input,
.register-dialog::v-deep input {
  color: white !important;
}

.register-title {
  background-color: #69032E;
  color: white;
}

.forgot-password {
  color: #931B4D !important;
  text-decoration: none;
  font-size: 13px;
}

.forgot-password:hover {
  text-decoration: underline;
}

/* === Drawer === */
.authenticated-drawer {
  border-right: 1px solid #282828 !important;
}

/* Etiqueta de plan en el menú (ej. «VIP» en Clientes) */
.drawer-tag {
  padding: 1px 8px;
  border: 1px solid #c9a24a;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #c9a24a;
}

.authenticated-drawer::v-deep .v-navigation-drawer__content {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.2) 100%),
              linear-gradient(90deg, #282828 0%, #282828 100%) !important;
}

.authenticated-drawer::v-deep .v-list {
  padding-top: 8px;
}

.drawer-item {
  min-height: 44px;
  transition: background-color 0.2s ease;
}

.drawer-item:hover {
  background-color: #282828 !important;
}

/* Auditoría P7: todas las secciones del menú con el mismo tamaño y peso, sin cortarse */
.drawer-item .v-list-item__title,
.drawer-group::v-deep .v-list-group__header .v-list-item__title {
  color: #ffffff !important;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.01em;
}

.drawer-item.v-list-item--active::before,
.drawer-submenu-item.v-list-item--active::before {
  opacity: 0.14 !important;
}

.drawer-item.v-list-item--active,
.drawer-submenu-item.v-list-item--active {
  box-shadow: inset 3px 0 0 #931B4D;
}

.drawer-icon {
  opacity: 0.7;
  filter: brightness(0) invert(1);
}

.drawer-subitem {
  padding-left: 24px !important;
}

.drawer-subitem .v-list-item__title {
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.37px;
}

.drawer-submenu-item {
  min-height: 30px !important;
  padding-left: 58px !important;
}

.drawer-submenu-item .v-list-item__title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #ffffff !important;
  letter-spacing: 0.37px;
}

.drawer-plus-icon {
  min-width: 14px !important;
  margin-right: 6px !important;
}

.drawer-plus-icon span {
  color: #ffffff;
  font-size: 14px;
  line-height: 1;
}

.drawer-group::v-deep .v-list-group__header__prepend-icon .v-icon {
  color: #C4C4C4 !important;
}

.divider-guinda {
  border-color: #282828 !important;
  opacity: 1 !important;
}

.guinda-text {
  color: #931B4D !important;
}

.logout-item:hover {
  background-color: rgba(147, 27, 77, 0.2) !important;
}

/* === Responsive === */
@media (max-width: 960px) {
  .nav-links {
    display: none !important;
  }
}

@media (max-width: 600px) {
  .login-btn {
    font-size: 13px !important;
    padding: 8px 10px !important;
    /* Con el botón de 40 px el menú ☰ se salía a 375 px: menos margen en celular */
    margin-left: 4px !important;
    margin-right: 4px !important;
  }

  .nfcero-logo {
    padding: 0 8px 0 12px;
  }
}

/* Celulares de menos de 375 px (muchos Android miden 360): logo y botones un poco más compactos para que quepa el menú */
@media (max-width: 374px) {
  .nfcero-logo {
    padding: 0 4px 0 8px;
  }

  .nfcero-logo .v-image {
    max-width: 88px !important;
  }

  .public-cart-icon {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .login-btn {
    font-size: 12px !important;
    padding: 8px 8px !important;
    margin-left: 2px !important;
    margin-right: 2px !important;
  }
}

/* === Animation === */
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 #931B4D;
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 10px 15px rgba(147, 27, 77, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(147, 27, 77, 0);
  }
}

.pulse-animation {
  animation: pulse 2s infinite;
}

/* Auditoría N4 */
.forgot-link.v-btn {
  text-decoration: underline;
  text-decoration-color: #931B4D;
  text-decoration-thickness: 2px;
  text-underline-offset: 4px;
  font-size: 15px;
}
</style>
